
export default {
  productData: {
    serialNumber: 'DA-MME-006',
    name: 'Massivholzdecke mit Estrich l Aufbau 6',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolldämmplatte WF<br>(<i>s‘</i> ≤ 10 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 72 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 40',
          value: 'scsb-40'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        }
      ],
      sum: {
        output: '240', value: 240
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '46 (-3; 5)',
        value: 46
      },
      soundReductionIndex: { // Rw
        output: '75 (-2; -7)',
        value: 75
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,52',
        value: 0.52
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '293 [kg/m²]'
      }
    }
  },
  image: 'da-mme-006.png',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-6-DA-MME-006-Rev01.pdf'
}
